import { toast } from "sonner";

export const socialPendingToast = (label, account) =>
    toast.info(`Find us on ${label}`, {
        description: `Search “${account}” — our direct link is being finalised.`,
    });

export const reviewsPendingToast = () =>
    toast.info("Find our reviews on Google", {
        description:
            "Search “Mākara Village Boarding Cattery” on Google to read our latest reviews.",
    });
